import React, { useEffect, useRef, useState } from 'react'
import './ShadowPage.scss'
import { mainApi } from '../../store/services/mainApi'
import ContentCard from '../components/Content/ContentCard/ContentCard'
import { useParams } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { setSearch } from '../../store/slices/search'
import { useLocation, useNavigate } from 'react-router'
import { setPriceIvaMode, setProMode } from '../../store/slices/contextUI'
import { Switch } from '@mui/material'
import axios from 'axios'
import CarNav from '../components/assets/images/Car-Nav.png'
import Slider from '@mui/material/Slider'
import TableCard from '../components/Card/TableCard/TableCard'
import LineCard from '../components/Card/LineCard/LineCard'
import CategoryFilterModal from '../components/ModalWindows/CategoryFilterModal/CategoryFilterModal'
import NavAlphaList from '../components/NavAlphaList/NavAlphaList'
import { ReactComponent as AlpaSortIcon } from '../components/assets/images/sortAlfabetIcon.svg'
import CarLoader from '../components/CarLoader/CarLoader'
import useSendLog from '../../hooks/useSendLog'
import useChangePageTitle from '../../hooks/useChangePageTitle'
import replaceAccent from '../../hooks/replaceAccent'
import FastTempleOrder from '../components/FastTempleOrder/FastTempleOrder'
import { ReactComponent as PDFICON } from '../components/assets/images/PDFICON.svg'
import { usePDF } from '@react-pdf/renderer'
import PDFOrders from './PDFOrders/PDFOrders'
import { Helmet } from 'react-helmet-async'
import CUIRadioButton from '../CatalogPage/CUIRadioButton/CUIRadioButton'
import { digitalAppApi } from '../../store/services/digitalAppApi'
import { ReactComponent as SettingsIcon } from '../components/assets/settingsIcon.svg'
import { ReactComponent as ResetIcon } from '../components/assets/ResetIcon.svg'
import { ReactComponent as BackspaceIcon } from '../components/assets/backspaceIcon.svg'
import { catalogs } from '../../constants/catalogs'

const optionsMode = [
  {name: 'TPO', color: '#5FC56E '},
  // {name: <span style={{ color: '#fce600', fontWeight: 'bold' }}>M</span>, color: '#155dfc '}
]

export default function ShadowPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const tradeName = useParams().tradeName
  const {
    data: contact,
    isLoading,
    isError,
  } = mainApi.useGetBuisnessContactByTradeNameQuery(tradeName, {
    skip: !tradeName,
  })
  const { data: marcoPersonal, isLoading: isLoadingMarcoPersonal } = digitalAppApi.useGetMakroPersonalQuery(tradeName, { skip: !tradeName })
  const platformParam = useParams().platform
  const [searchText, setSearchText] = useState('')
  const dispatch = useDispatch()
  const { categoryName, categoryType } = useParams()
  const [sortAlphabetProductsData, setSortAlphabetProductsData] = useState([])
  const view = useSelector((state) => state.contextUI.proMode)

  const { data: SPOList = [], isLoading: isLOadingList } = mainApi.useGetClientPersonalSalesQuery(tradeName)
  const [spoList, setSpoList] = useState([])
  useEffect(() => {
    if (!isLOadingList) {
      if (SPOList) {
        setSpoList(
          SPOList?.filter((el) => el.selected)?.map((el) => {
            const { selected, ...rest } = el
            return rest
          }),
        )
      }
    }
  }, [SPOList])

  const [personalData, setPersonalData] = useState({})
  useChangePageTitle(tradeName, setPersonalData)

  const { data: orderData, isLoading: isLoadingOrder } = mainApi.useGetOrderItemsByTradeNameQuery(tradeName)
  const { data: allProductsData = [], isLoading: isLoadingProducts } = mainApi.useFindAllWordsQuery()

  function replaceItem(item) {
    return { sku: item.sku, name: replaceAccent(item?.name && typeof item?.name !== 'string' ? item?.name?.toLowerCase() : '') }
  }

  const [searchDataMap, setSearchDataMap] = useState([])
  const [replaceNameData, setReplaceNameData] = useState([])

  useEffect(() => {
    if (sortAlphabetProductsData) {
      console.log(sortAlphabetProductsData)
      setReplaceNameData(sortAlphabetProductsData.map((item) => replaceItem(item)))
    }
  }, [sortAlphabetProductsData])
  const [localProductsFilter, setLocalProductsFilter] = useState(
    localStorage.getItem('FilteredCatalog') ? JSON.parse(localStorage.getItem('FilteredCatalog')) : [],
  )

  const replaceWord = replaceAccent(searchText?.toLowerCase())

  useEffect(() => {
    if (sortAlphabetProductsData && !isLoadingOrder) {
      const filterArray = replaceNameData?.filter((item) => replaceAccent(item.name?.toLowerCase()).includes(replaceWord))
      const rr = sortAlphabetProductsData
        ?.filter((el) => filterArray.map((item) => item.sku)?.includes(el.sku))
        ?.filter((el) => !localProductsFilter?.includes(el.sku))
        ?.filter((el) => el?.enabled != false)
      console.log(rr)

      if (!isLOadingList && SPOList !== undefined) {
        const spoMapSku = SPOList?.map((el) => el?.sku)

        const mergedArray = [...rr, ...SPOList]?.filter((el) => {
          if (spoMapSku?.includes(el?.sku)) {
            if (!el?.spoPrice) {
              return false
            } else {
              if (el?.selected) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        })
        setSearchDataMap(
          mergedArray
            ?.filter((el) => !(el?.sku)?.toString()?.slice(0, 3)?.includes('MCH'))
            ?.filter((el) => !(tradeName == 'KNZB' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'KNZV' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'KNZ2' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'KNZ1' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'GLB' && el.sku == 'ZumAmazGuayb1lt' && el.sku == 'LimaCat2KG'))
            ?.filter((el) => el.sku !== 'LimaCat2KG')
            // ?.filter((el) => !(el.sku == 'BroGhoaCilCitmac30/40gr' || el.sku == 'BLEMEkg'))
            ?.filter((item) => replaceAccent(item.name?.toLowerCase()).includes(replaceWord))
            ?.filter((el) => el.enabled != false),
        )
      } else {
        setSearchDataMap(
          rr
            ?.filter((el) => !(el?.sku)?.toString()?.slice(0, 3)?.includes('MCH'))
            ?.filter((el) => !(tradeName == 'KNZB' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'KNZV' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'KNZ2' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'KNZ1' && el.sku == 'BHieCILman'))
            ?.filter((el) => !(tradeName == 'GLB') && el.sku == 'ZumAmazGuayb1lt' && el.sku == 'LimaCat2KG')
            // ?.filter((el) => el.sku !== 'LimaCat2KG')
            // ?.filter((el) => !(el.sku == 'BroGhoaCilCitmac30/40gr' || el.sku == 'BLEMEkg'))
            ?.filter((item) => replaceAccent(item.name?.toLowerCase()).includes(replaceWord))
            ?.filter((el) => el.enabled != false),
        )
      }
    }
  }, [replaceNameData, searchText, localProductsFilter, isLOadingList])

  useEffect(() => {
    if (!isLoadingOrder && orderData !== undefined) {
      const editData = orderData?.map((el) => {
        return {
          ...el,
          quantity: 0,
          quantityOrder: 0,
        }
      })
      setSortAlphabetProductsData(
        [...editData].sort(function (a, b) {
          if (a.name < b.name) return -1
        }),
      )
    }
  }, [orderData, allProductsData])

  useEffect(() => {
    if (location.pathname === '/home') {
      dispatch(setSearch(''))
    }
  })

  const userData = useSelector((state) => state.accountData.userAcc)
  const [id, setId] = React.useState('')
  const isLogin = useSelector((state) => state.contextUI.isLogin)
  useEffect(() => {
    if (tradeName !== '') {
      const tradeId = async () => {
        const responseLogin = await axios.get(`https://tpomobi.shop/getBuisnessContactByTradeName?tradeName=${tradeName}`)
        setId(responseLogin.data?.sku)
        const localStorageData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
        localStorage.setItem(
          'userData',
          JSON.stringify({
            ...localStorageData,
            tradeNameAdress: responseLogin.data?.name,
            tradeNameCode: responseLogin.data?.tradeName,
          }),
        )
      }
      tradeId()
    }
  }, [userData, isLogin])
  useEffect(() => {
    setId()
  }, [])
  const ivaSwitch = useSelector((state) => state.contextUI.PriceIVA)
  const [filterCategory, setFilterCategory] = useState(false)
  const [seenAll, setSeenAll] = useState(false)

  const [oldView, setOldView] = useState(view)
  const handleInputChange = useSendLog('Change view of cards in personal link', {
    changes: {
      view: { old: oldView, new: view },
    },
  })
  const handleAlpabetSortBtn = useSendLog('Click on alphabet navigation', {})
  const handleFilterItemsLink = useSendLog('Click on filter items modal links', {})

  useEffect(() => {
    if (searchDataMap?.length + spoList?.length > 0) {
      window.location.reload()
    }
  }, [])
  useEffect(() => {
    console.log(searchDataMap)
  }, [searchDataMap])

  const isNY25 = useParams().tradeName == 'NY25' ? true : false

  const [instancePDf, updatePDF] = usePDF({
    document: <PDFOrders contact={{}} items={[]} />,
  })

  useEffect(() => {
    if (contact) {
      updatePDF(<PDFOrders contact={contact} items={[...spoList, ...searchDataMap]} />)
      // console.log(contact)
    }
  }, [contact, searchDataMap])

  const downloadLinkRef = useRef(null);

  // Создайте ссылку один раз при монтировании
  useEffect(() => {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.id = 'download-link';
    document.body.appendChild(link);
    downloadLinkRef.current = link;

    return () => {
      if (downloadLinkRef.current) {
        document.body.removeChild(downloadLinkRef.current);
      }
    };
  }, []);

  return (
    <div className='categoriesMain' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Helmet>
        <title>Your personal Link: {tradeName}</title>
        {/* <meta property="og:title" content={`Your personal Link: ${tradeName}`} />
        <meta property="og:description" content={`Products for you: ${(searchDataMap.length+spoList.length)}`} />
        <meta property="og:image" content="https://i.imgur.com/9tXrg46.png" />
        <meta property="og:url" content={"https://tpoapp.com/category/"+tradeName} />
        <meta property="og:type" content="website" /> */}
      </Helmet>
      

      <div className='wrapper'>
        <div className="wrapper__Profile">
          {personalData && <div className="profile">
            <div className="profile__img">
              <img src={personalData.img} alt="" />
            </div>
            <div className="profile__name">
              {personalData?.employee}
            </div>
          </div>}
          <div className="cardView">
            <p>Con fotos</p>
            <Slider
              step={1}
              min={1}
              max={3}
              value={view}
              onChange={(e) => {
                setOldView(view)
                dispatch(setProMode(e.target.value))
                handleInputChange()
              }}
              sx={{
                width: '80px',
                margin: 'px 20px',
                color: '#5FC56E',
              }}
            />
            <p>La lista</p>
          </div>
          <div className="catalog">
            {marcoPersonal?.data?.length > 0 ? (
                <CUIRadioButton
                  options={[optionsMode[0], ...catalogs.filter((catalog) => marcoPersonal?.data?.filter((el) => el?.sku?.slice(0, 3)?.includes(catalog?.skus))?.length > 0)]}
                  value={optionsMode[0]?.name}
                  onChange={(e) => {
                    if (e.link) {
                      navigate('/catalog/' + e.link + '/' + tradeName)
                    } else {
                      navigate('/category/' + tradeName)
                    }
                  }}
                  sx={{
                    boxShadow: '0 0px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                  }}
                  getOptionLabel={(e) => e?.name}
                  getOptionValue={(e) => e?.name}
                  color='#5FC56E'
                />
            ) : null}
            <p>Artículos en el catálogo:</p>
            <span>
              {searchDataMap?.length + spoList?.length}
              {catalogs?.map((catalog, index) => 
                {
                  console.log(marcoPersonal?.data?.map((el) => el?.sku?.slice(0, 3)?.includes(catalog?.skus)))
                  const count = marcoPersonal?.data?.filter((el) => el?.sku?.slice(0, 3)?.includes(catalog?.skus))?.length
                  return (count > 0 && <div 
                    style={{ color: catalog?.color}}
                    key={index}
                  >
                    /{count}
                  </div>)}
              )}
            </span>
          </div>
        </div>

        <div className='wrapper__settings'>
          <span>IVA</span>
          <div className="params">
            <div className="switch">
              <p>Los precios:</p>
              <div className="content">
                <div className='label'>
                  sin
                </div>
                <Switch
                  className='ProfileMobile__status__switch'
                  checked={ivaSwitch}
                  onChange={() => {
                    dispatch(setPriceIvaMode(!ivaSwitch))
                  }}
                  sx={{
                    width: '68px',
                    '& .MuiSwitch-root .MuiSwitch-sizeMedium': {
                      width: '66px',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#fff !important',
                      widows: '20px',
                    },
                    '& .Mui-checked+.MuiSwitch-track': {
                      backgroundColor: '#5FC56E !important',
                    },

                    '& .MuiSwitch-track': {
                      height: '24px',
                      width: '70px',
                      borderRadius: '14px',

                      transform: 'translateX(-5px) translateY(-5px)',
                    },
                  }}
                />
                <div className='label'>
                  con
                </div>

              </div>
            </div>
            <div className="btnBox">
              <button
                className='outline'
                onClick={() => {
                  setFilterCategory(true)
                  handleFilterItemsLink()
                }}
              >
                <SettingsIcon />
              </button>
              <CategoryFilterModal setFilterCategory={setFilterCategory} filterCategory={filterCategory} />
              {instancePDf.loading ? (
                <CircularProgress size={25} color='success' />
              ) : (
                <button
                  className='filled'
                  onClick={() => {
                    updatePDF(<PDFOrders contact={contact} items={[...spoList, ...searchDataMap]} />);
                    
                    // Используем существующую ссылку
                    setTimeout(() => {
                      if (instancePDf.url && downloadLinkRef.current) {
                        downloadLinkRef.current.href = instancePDf.url;
                        downloadLinkRef.current.download = `Catalogo - ${contact?.employee}.pdf`;
                        downloadLinkRef.current.click();
                      }
                    }, 100);
                  }}
                >
                  <PDFICON height={16} width={16} />
                </button>
              )}
            </div>
          </div>
        </div>
        
        <div className="wrapper__search">
          <div className="search">
            <input 
              type='text' 
              value={searchText} 
              onChange={(e) => setSearchText(e.target.value)} 
              placeholder='Buscar en mi lista...'  
            />

            <button
              className='btn'
              style={{ display: searchText !== '' ? 'flex' : 'none' }}
              onClick={() => setSearchText('')}
            >
              <BackspaceIcon />
            </button>
            <button
              className='btn'
              onClick={() => {
                window.scrollTo({ top: 251, behavior: 'smooth' })
                handleAlpabetSortBtn()
              }}
            >
              <AlpaSortIcon width={24} heigth={24}/>
            </button>
          </div>
          <div className="btnBox">
            <button
              className='btn'
              onClick={() => window.location.reload()}
            >
              <ResetIcon />
              Recargar catálogo
            </button>
            {!isNY25 && (
              <FastTempleOrder
                sx={{ container: { width: '100%' } }}
                sxBtn={{
                  boxShadow: '0 2px 4px -2px rgba(0, 0, 0, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  background: '#00c950',
                  borderRadius: '8px',
                  padding: '10px',
                  boxSizing: 'border-box',
                  width: '100%',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  gap: '16px',
                  outline: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.9s ease',

                  fontFamily: 'Arial',
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '20px',
                  color: '#fff',
                  textAlign: 'center',
                  textWrap: 'nowrap',
                }}
                textBtn={'Repetir pedido'}
              />
            )}
          </div>
        </div>

      </div>


      <div className='categoriesPage' style={{ justifyContent: 'space-around' }}>
        {!isLOadingList && spoList?.filter((item) => replaceAccent(item?.name?.toLowerCase()).includes(replaceWord))?.length > 0 && (
          <div className='SPOBox'>
            <div className='SPOBox__title'>Tu Precio de Oferta</div>
            <div className='SPOBox__list'>
              {view === 1
                ? spoList
                    ?.map((item) =>
                      tradeName === 'OURS' && item?.name == 'Aguacate Hass 18/20 calibre kg' ? { ...item, spoPrice: item?.marketPrice } : item,
                    )
                    ?.filter((item) => replaceAccent(item?.name?.toLowerCase()).includes(replaceWord))
                    ?.sort((a, b) => a?.name?.localeCompare(b.name))
                    ?.map((item, index) => <ContentCard card={item} key={item.title + item.sku + index} />)
                : view === 3
                ? spoList
                    ?.map((item) =>
                      tradeName === 'OURS' && item?.name == 'Aguacate Hass 18/20 calibre kg' ? { ...item, spoPrice: item?.marketPrice } : item,
                    )
                    ?.filter((item) => replaceAccent(item?.name?.toLowerCase()).includes(replaceWord))
                    ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                    ?.map((item, index) => <LineCard item={item} key={item?.title + item?.sku + index} />)
                : spoList
                    ?.map((item) =>
                      tradeName === 'OURS' && item?.name == 'Aguacate Hass 18/20 calibre kg' ? { ...item, spoPrice: item?.marketPrice } : item,
                    )
                    ?.filter((item) => replaceAccent(item?.name?.toLowerCase()).includes(replaceWord))
                    ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                    ?.map((item, index) => <TableCard item={item} key={item?.title + item?.sku + index} />)}
            </div>
          </div>
        )}
        <NavAlphaList
          list={
            !seenAll
              ? searchDataMap?.sort((a, b) => a?.name?.localeCompare(b?.name))?.slice(0, 50)
              : searchDataMap?.sort((a, b) => a?.name?.localeCompare(b?.name))
          }
          view={view}
          more={seenAll}
          setMore={setSeenAll}
        >
          {!seenAll ? (
            isLoadingOrder ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '28px',
                  marginLeft: '60px',
                  fontWeight: '700',
                  color: '#5fc56e',
                  textAlign: 'center',
                }}
              >
                <CarLoader />
                <span style={{ width: '80%' }}>Por favor espera, se está cargando tu lista de productos</span>
              </div>
            ) : view === 1 ? (
              searchDataMap
                ?.slice(0, 50)
                .sort((a, b) => a?.name?.localeCompare(b?.name))
                ?.map((item) => (
                  <div key={item?.id} className='NavAlphaList__list-item' data-letter={item?.name[0]?.toUpperCase()} style={{ width: 'fit-content' }}>
                    <ContentCard card={item} key={item?.title + item?.sku} />
                  </div>
                ))
            ) : view === 3 ? (
              searchDataMap
                ?.slice(0, 50)
                .sort((a, b) => a?.name?.localeCompare(b?.name))
                ?.map((item) => (
                  <div key={item?.id} className='NavAlphaList__list-item' data-letter={item?.name[0]?.toUpperCase()}>
                    <LineCard item={item} key={item?.title + item?.sku} />
                  </div>
                ))
            ) : (
              searchDataMap
                ?.slice(0, 50)
                .sort((a, b) => a?.name?.localeCompare(b?.name))
                ?.map((item) => (
                  <div key={item?.id} className='NavAlphaList__list-item' data-letter={item?.name[0]?.toUpperCase()} style={{ marginLeft: '20px' }}>
                    <TableCard item={item} />
                  </div>
                ))
            )
          ) : isLoadingOrder ? (
            <CircularProgress />
          ) : view === 1 ? (
            searchDataMap
              ?.sort((a, b) => a?.name?.localeCompare(b?.name))
              ?.map((item) => (
                <div key={item?.id} className='NavAlphaList__list-item' data-letter={item?.name[0]?.toUpperCase()} style={{ width: 'fit-content' }}>
                  <ContentCard card={item} key={item?.title + item?.sku} />
                </div>
              ))
          ) : view === 3 ? (
            searchDataMap
              ?.sort((a, b) => a.name?.localeCompare(b.name))
              ?.map((item) => (
                <div key={item?.id} className='NavAlphaList__list-item' data-letter={item?.name[0]?.toUpperCase()}>
                  <LineCard item={item} key={item?.title + item?.sku} />
                </div>
              ))
          ) : (
            searchDataMap
              ?.sort((a, b) => a.name?.localeCompare(b.name))
              ?.map((item) => (
                <div key={item?.id} className='NavAlphaList__list-item' data-letter={item?.name[0]?.toUpperCase()} style={{ marginLeft: '20px' }}>
                  <TableCard item={item} />
                </div>
              ))
          )}
        </NavAlphaList>
        {!seenAll && searchDataMap?.length > 50 && (
          <div
            className='ThanksModal__backBtn'
            style={{ margin: 'auto', marginTop: '20px', color: '#fff', cursor: 'pointer', width: '100%' }}
            onClick={() => {
              setSeenAll(true)
            }}
          >
            Ver todo
          </div>
        )}
      </div>

      <div
        className='ThanksModal__backBtn'
        style={{ margin: 'auto', marginTop: '20px', color: '#fff', cursor: 'pointer' }}
        onClick={() => {
          if (platformParam !== undefined) {
            navigate(`/newOrder/${platformParam}/${tradeName}`)
          } else {
            navigate(`/newOrder/${tradeName}`)
          }
          window.scrollTo(0, 0)
        }}
      >
        Ver furgoneta
        <img src={CarNav} alt='' style={{ filter: 'brightness(0) invert(1)', width: '30px', marginLeft: '10px' }} />
      </div>
    </div>
  )
}
